import type { MouseEvent } from "react";
import { t } from "ttag";

import { Flex, Icon, Tooltip, UnstyledButton } from "metabase/ui";

import type { Status } from "./types";

type Props = {
  className?: string;
  highlighted?: boolean;
  status: Status;
  onClick?: () => void;
};

export const WidgetStatus = ({
  className,
  highlighted,
  status,
  onClick,
}: Props) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      event.stopPropagation();
      onClick();
    }
  };

  return (
    <Flex
      align="center"
      className={className}
      h={0} // trick to prevent this element from affecting parent's height
      ml="auto"
      style={{ pointerEvents: onClick ? "auto" : "none" }}
    >
      {status === "clear" && (
        <Tooltip label={t`Clear`}>
          <UnstyledButton
            aria-label={t`Clear`}
            h={24}
            onClick={handleClick}
            py={4}
            type="button"
          >
            <Icon
              name="close"
              c={highlighted ? undefined : "text-secondary"}
              size={16}
            />
          </UnstyledButton>
        </Tooltip>
      )}

      {status === "reset" && (
        <Tooltip label={t`Reset filter to default state`}>
          <UnstyledButton
            aria-label={t`Reset filter to default state`}
            h={24}
            onClick={handleClick}
            py={4}
            type="button"
          >
            <Icon
              name="revert"
              c={highlighted ? undefined : "text-secondary"}
              size={16}
            />
          </UnstyledButton>
        </Tooltip>
      )}

      {status === "empty" && <Icon size={16} name="chevrondown" />}

      {status === "none" && <Icon name="empty" />}
    </Flex>
  );
};
